import { Component, ViewChild, Output, EventEmitter, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';

import { AbstractComponent } from 'src/core/common/component/AbstractComponent';

import { GSCaptureService } from './GSCaptureService';

@Component({
  selector: 'gs-capture',
  templateUrl: './GSCapture.html',
  styleUrls: ['./GSCapture.scss']
})
export class GSCaptureComponent extends AbstractComponent {
  @Input('id')
  public id: any;
  @Input('name')
  public name: any;

  @ViewChild('videoPlayer') 
  public videoPlayer: ElementRef;
  public filePath;
  
  public scope = {
    wait : true
  };
  
  public constructor(private service:GSCaptureService,
                     private el: ElementRef) {
    super();
  }

  /** show */
  public componentWillMount() {
    this.loadVideo();
  }
  public componentDidMount() {
    setTimeout(() => {
      this.videoPlayer.nativeElement.addEventListener('loadeddata',() => {
        this.scope.wait = false;
      });  
    }, 100)

  }

  public loadVideo() {
    this.filePath = this.service.get(this.id);
  }
}
